'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Vince = function () {
    function Vince(module) {
        (0, _classCallCheck3.default)(this, Vince);


        // Caching the module element.
        this.module = module;

        // Caching the button that opens the overlay.
        this.btn = this.module.querySelector('#vince--cta');

        // Caching a reference to the body element.
        this.body = document.querySelector('body');

        // Caching the modal element.
        this.modal = document.querySelector('#modal');
    }

    // Initializes event bindings.


    Vince.prototype.init = function init() {
        var _this = this;

        // Binding the click event for the open modal button.
        this.btn.onclick = function () {
            return _this.open();
        };
    };

    // Opens the vince modal.


    Vince.prototype.open = function open() {

        // Find and enable the vince modal.
        var modalView = this.modal.querySelector('.modal--wrap[data-name="vince"]');
        if (modalView !== null) {
            modalView.setAttribute('aria-hidden', 'false');
            this.modal.setAttribute('aria-hidden', 'false');
            this.body.setAttribute('data-scroll-pos', window.scrollY);
            this.body.setAttribute('data-scrollable', 'false');
        }

        // Send tracking event
        gtag('event', 'More About Vince', { // eslint-disable-line
            'event_category': 'Nav', // eslint-disable-line
            'event_action': 'click', // eslint-disable-line
            'event_label': 'vincemore' // eslint-disable-line
        }); // eslint-disable-line
    };

    return Vince;
}();

var _module = document.querySelector('#vince');
if (_module !== null) {
    var vinceComponent = new Vince(_module);
    vinceComponent.init();
}


//////////////////
// WEBPACK FOOTER
// ./src/components/vince/vince.js
// module id = 4
// module chunks = 0